export const lStorage = {
    set: _set,
    get: _get,
    arrayGet: _arrayGet,
    arrayPush: _arrayPush,
    del,
    delLike
};

export const lStorageKeys = {
    // jezyk aplikacji
    APP_LANG: 'APP_LANG',

    // glowny access token uzytkownika
    AUTH_ACCESS_TOKEN: 'AUTH_ACCESS_TOKEN',

    // glowne dane uzytkownika
    AUTH_USER: 'AUTH_USER',

    // prefix danych glownego menu strony (aktualnosci, naleznosci itd)
    HEAD_MENU_PREFIX: 'MENU_',

    // prefix danych menu kategorii produktowych
    CATALOG_MENU_PREFIX: 'CATALOG_MENU_',
    CATALOG_MENU_EXPIRE_PREFIX: 'CATALOG_MENU_EXPIRE_',

    // ustawienia przegladania produktow na liscie (domyslny widok,
    // sortowanie i ustawienia dostepnosci)
    CATALOG_VIEW: 'CATALOG_VIEW',
    CATALOG_SORT: 'CATALOG_SORT',
    CATALOG_ON_STOCK: 'CATALOG_ON_STOCK',

    // ostatnio przegladane produkty przez uzytkownika
    LAST_VIEWED_PRODUCTS: 'LAST_VIEWED_PRODUCTS',

    //status zgody na regulamin RMA
    RMA_CONFIRMATION: 'RMA_CONFIRMATION',
    //posiadanie przez klienta dostepu do loadera plikow csv dla rma
    RMA_CSV_LOADER: 'RMA_CSV_LOADER'
};

function _set(name, val) {
    if(typeof Storage == "undefined") return;
    localStorage.setItem(process.env.APP_NAME+'_'+name, val);
}

function _get(name) {
    if(typeof Storage == "undefined") return;
    return localStorage.getItem(process.env.APP_NAME+'_'+name)
}

function del(name) {
    if(typeof Storage == "undefined") return;
    return localStorage.removeItem(process.env.APP_NAME+'_'+name)
}

function delLike(name) {
    if(typeof Storage == "undefined") return;
	let myReg = new RegExp(process.env.APP_NAME+'_'+name + ".*")
	for (var key in localStorage){
   		if (key.match(myReg)) {
   			localStorage.removeItem(key)
   		}
	}
	return true;

}

function _arrayGet(name) {
    if(typeof Storage == "undefined") return;
    let value = localStorage.getItem(process.env.APP_NAME + '_' + name);

    if (value === null) {
        return [];
    }

    return JSON.parse(localStorage.getItem(process.env.APP_NAME + '_' + name));
}

/**
 * dodawanie elementu do local storage jak do zwyklej tablicy.
 *
 * korzystajac z limit mozemy ustawic maksymalna liczbe elementow
 * w tablicy. w przypadku braku miejsca zostanie usuniety
 * element ktory zostal dodany do tablicy jako pierwszy.
 *
 * removeDuplicates pozwala na usuniecie elementow ktore
 * sa w tablicy identyczne.
 *
 * @param name
 * @param value
 * @param limit
 * @param removeDuplicates
 */
function _arrayPush(name, value, limit = 0, removeDuplicates = false) {
    if(typeof Storage == "undefined") return;

    let data = _arrayGet(name);

    if (removeDuplicates) {
        data.forEach(function (dataValue, index) {
            if (JSON.stringify(dataValue) === JSON.stringify(value)) {
                data.splice(index, 1);
            }
        });
    }

    if (limit && data.length >= limit) {
        data = data.slice(1, limit);
    }

    data.push(value);

    localStorage.setItem(process.env.APP_NAME + '_' + name, JSON.stringify(data));
}